/* App calls (27 Oct 2026, mocks AppCall_1 + AppCall_2; 30 Oct, AppCall_3): every Call goes
   through Sramika's app-call number - customers without login, and desk staff too (for
   themselves or for a customer). The server hands back a 4-digit code for this car or
   driver; the dialer opens with our number, a pause and the code, which the phone sends by
   itself. Nobody's number is on the page.
   2 free calls per 6 hours: the 2nd says it is the last; after that ₹29 from the wallet
   (callWithWalletGate). Without a login the phone keeps the count and the 3rd asks for the
   login. A driver's own car or profile: a notice, no call. */

import { apiRequest } from "./api";
import { getUserRole } from "./auth";
import { track } from "./analytics";
import { callWithWalletGate, askGate, WALLET_GATE_CANCELLED } from "./walletGate";
import { askOnBehalf, ON_BEHALF_CANCELLED } from "../components/OnBehalfHost";

const STAFF = ["ADMIN", "SUPER_ADMIN", "ONBOARDING_AGENT"];
const LOCAL = "sr_app_calls";
const FREE = 2, HOURS = 6;

function localCount() {
  try {
    const x = JSON.parse(localStorage.getItem(LOCAL) || "null");
    if (x && Date.now() - x.start < HOURS * 3600000) return x;
  } catch { /* storage off: no count */ }
  return { start: 0, n: 0 };
}
function bumpLocal() {
  try { const x = localCount(); localStorage.setItem(LOCAL, JSON.stringify({ start: x.n ? x.start : Date.now(), n: x.n + 1 })); } catch { /* ignore */ }
}

/**
 * Starts an app call. true: handled (dialing, or the person stopped, or told why not);
 * "LOGIN": sign in first (a 3rd call without a login); false: app calls are off - the page
 * carries on with its own flow.
 */
export async function startAppCall({ kind, body, driverId, page }) {
  const role = getUserRole();
  let onBehalf = null;
  if (STAFF.includes(role)) {
    const ob = await askOnBehalf();
    if (ob === ON_BEHALF_CANCELLED) return true;
    onBehalf = ob || null;
  }
  if (!role) {
    const x = localCount();
    if (x.n >= FREE) return "LOGIN";
    if (x.n === FREE - 1 && (await askGate({ kind: "last", free: FREE, resetsAt: new Date(x.start + HOURS * 3600000).toISOString() })) !== "call") return true;
  }
  try {
    const res = await callWithWalletGate(({ confirmPaid }) => apiRequest("/app-call", {
      method: "POST", body: JSON.stringify({ kind, body, driverId, page, confirmPaid, ...(onBehalf ? { onBehalf } : {}) }) }));
    if (!res?.success || !res?.dial) return false;
    if (!role) bumpLocal();
    track("app_call_dialed", { type: kind, page, carId: body?.carId, driverId, plan: res.plan || null });
    window.location.href = res.dial;
    return true;
  } catch (err) {
    if (err?.code === "OFF") return false;
    if (err?.code === WALLET_GATE_CANCELLED) return true;
    if (err?.code === "OWN") { await askGate({ kind: "own", driver: kind === "driver" }); return true; }
    await askGate({ kind: "failed", message: err?.message || null });
    return true;
  }
}
